import Duck from 'extensible-duck';
import {
  SCRIBE_STATE_NAMES,
  SCRIBE_EXPRESS_BULK_UPLOAD_WEB_EVENTS,
  SCRIBE_EXPRESS_BULK_UPLOAD_REVIEW_WEB_EVENTS,
  SCRIBE_BULK_UPLOAD_EDIT_ADDRESS_EVENTS,
  SCRIBE_EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_EVENTS,
  SCRIBE_EXPRESS_BULK_UPLOAD_ERROR_PAGE,
  SCRIBE_EXPRESS_BULK_UPLOAD_BOOK_WEB_EVENTS,
} from 'applications/scribe/instrumentations/track';

export default new Duck({
  namespace: 'GEWEB',
  store: 'SCRIBE-BULKUPLOAD',
  types: [
    'EXPRESS_BULK_UPLOAD_WEB_DOWNLOAD_TEMPLATE',
    'EXPRESS_BULK_UPLOAD_WEB_UPLOAD',
    'EXPRESS_BULK_UPLOAD_WEB_BACK',
    'EXPRESS_BULK_UPLOAD_WEB_SUCCESS_UPLOAD',
    'EXPRESS_BULK_UPLOAD_NAVIGATE_STEP',

    'EXPRESS_BULK_UPLOAD_REVIEW_WEB_DEFAULT',
    'EXPRESS_BULK_UPLOAD_REVIEW_WEB_SELECT_ALL_ROWS',
    'EXPRESS_BULK_UPLOAD_REVIEW_WEB_SELECT_ROWS_WITH_ERROR',
    'EXPRESS_BULK_UPLOAD_REVIEW_WEB_EDIT_ADDRESS',
    'EXPRESS_BULK_UPLOAD_REVIEW_WEB_CONFIRM',

    'EXPRESS_BULK_UPLOAD_EDIT_ADDRESS_WEB_DEFAULT',
    'EXPRESS_BULK_UPLOAD_EDIT_ADDRESS_WEB_ADDRESS',
    'EXPRESS_BULK_UPLOAD_EDIT_ADDRESS_WEB_LOCATION_NOTES',
    'EXPRESS_BULK_UPLOAD_EDIT_ADDRESS_WEB_CANCEL',
    'EXPRESS_BULK_UPLOAD_EDIT_ADDRESS_WEB_CONFIRM',

    // BUR Step 3
    'EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_DEFAULT',
    'EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_SELECT_ALL',
    'EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_EDIT_SERVICE_TYPE',
    'EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_EDIT_VEHICLE_TYPE',
    'EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_EDIT_ADD_ON',
    'EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_CONFIRM',

    'EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_TOGGLE_MULTI_STOP',
    'EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_REVIEW_MULTI_STOP',
    'EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_USE_ORIGINAL_ROUTE',
    'EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_FIND_SHORTEST_ROUTE',
    'EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_FIND_SHORTEST_ROUTE_RESULTS',

    'EXPRESS_BULK_UPLOAD_ERROR_PAGE_DEFAULT',
    'EXPRESS_BULK_UPLOAD_ERROR_PAGE_CONFIRM_INVALID_FIELD',

    // BUR Step 4
    'EXPRESS_BULK_UPLOAD_BOOK_WEB_DEFAULT',
    'EXPRESS_BULK_UPLOAD_BOOK_WEB_PAYMENT_METHOD',
    'EXPRESS_BULK_UPLOAD_BOOK_WEB_OFFERS',
    'EXPRESS_BULK_UPLOAD_BOOK_WEB_BOOK',
  ],
  reducer: (state, action, duck) => state,
  creators: duck => ({
    //STEP1
    scribeExpressNewBulkUploadStep1DownloadTemplate: () => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_WEB_DOWNLOAD_TEMPLATE,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_WEB,
      eventName: SCRIBE_EXPRESS_BULK_UPLOAD_WEB_EVENTS.DOWNLOAD_TEMPLATE,
    }),
    scribeExpressNewBulkUploadStep1Upload: () => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_WEB_UPLOAD,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_WEB,
      eventName: SCRIBE_EXPRESS_BULK_UPLOAD_WEB_EVENTS.UPLOAD,
    }),
    scribeExpressNewBulkUploadStep1Back: () => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_WEB_BACK,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_WEB,
      eventName: SCRIBE_EXPRESS_BULK_UPLOAD_WEB_EVENTS.BACK,
    }),
    scribeExpressNewBulkUploadStep1SuccessUpload: () => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_WEB_SUCCESS_UPLOAD,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_WEB,
      eventName: SCRIBE_EXPRESS_BULK_UPLOAD_WEB_EVENTS.SUCCESS_UPLOAD,
    }),
    scribeBulkUploadNavigateStep: (currentStep, toStep) => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_NAVIGATE_STEP,
      currentStep,
      toStep,
    }),

    //STEP2
    scribeExpressNewBulkUploadStep2Default: (totalRow, errorCode, districtUsage, totalAddressCount) => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_REVIEW_WEB_DEFAULT,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_REVIEW_WEB,
      eventName: SCRIBE_EXPRESS_BULK_UPLOAD_REVIEW_WEB_EVENTS.DEFAULT,
      totalRow,
      errorCode,
      districtUsage,
      totalAddressCount,
    }),
    scribeExpressNewBulkUploadStep2SelectAllRows: () => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_REVIEW_WEB_SELECT_ALL_ROWS,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_REVIEW_WEB,
      eventName: SCRIBE_EXPRESS_BULK_UPLOAD_REVIEW_WEB_EVENTS.SELECT_ALL_ROWS,
    }),
    scribeExpressNewBulkUploadStep2SelectRowsWithError: () => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_REVIEW_WEB_SELECT_ROWS_WITH_ERROR,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_REVIEW_WEB,
      eventName:
        SCRIBE_EXPRESS_BULK_UPLOAD_REVIEW_WEB_EVENTS.SELECT_ROWS_WITH_ERROR,
    }),
    scribeExpressNewBulkUploadStep2EditAddress: () => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_REVIEW_WEB_EDIT_ADDRESS,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_REVIEW_WEB,
      eventName: SCRIBE_EXPRESS_BULK_UPLOAD_REVIEW_WEB_EVENTS.EDIT_ADDRESS,
    }),
    scribeExpressNewBulkUploadStep2Confirm: () => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_REVIEW_WEB_CONFIRM,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_REVIEW_WEB,
      eventName: SCRIBE_EXPRESS_BULK_UPLOAD_REVIEW_WEB_EVENTS.CONFIRM,
    }),

    //STEP2 edit address
    scribeExpressNewBulkUploadStep2EditAddressDrawerDefault: (
      poiType,
      originAddress,
      adjustedAddress,
      adminArea,
    ) => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_EDIT_ADDRESS_WEB_DEFAULT,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_EDIT_ADDRESS_WEB,
      eventName: SCRIBE_BULK_UPLOAD_EDIT_ADDRESS_EVENTS.DEFAULT,
      poiType,
      originAddress,
      adjustedAddress,
      adminArea,
    }),
    scribeExpressNewBulkUploadStep2EditAddressDrawerAddress: adjustedAddress => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_EDIT_ADDRESS_WEB_ADDRESS,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_EDIT_ADDRESS_WEB,
      eventName: SCRIBE_BULK_UPLOAD_EDIT_ADDRESS_EVENTS.ADDRESS,
      adjustedAddress,
    }),
    scribeExpressNewBulkUploadStep2EditAddressDrawerLocationNotes: () => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_EDIT_ADDRESS_WEB_LOCATION_NOTES,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_EDIT_ADDRESS_WEB,
      eventName: SCRIBE_BULK_UPLOAD_EDIT_ADDRESS_EVENTS.LOCATION_NOTES,
    }),
    scribeExpressNewBulkUploadStep2EditAddressDrawerCancel: originAddress => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_EDIT_ADDRESS_WEB_CANCEL,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_EDIT_ADDRESS_WEB,
      eventName: SCRIBE_BULK_UPLOAD_EDIT_ADDRESS_EVENTS.CANCEL,
      originAddress,
    }),
    scribeExpressNewBulkUploadStep2EditAddressDrawerConfirm: (
      originAddress,
      adjustedAddress,
    ) => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_EDIT_ADDRESS_WEB_CONFIRM,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_EDIT_ADDRESS_WEB,
      eventName: SCRIBE_BULK_UPLOAD_EDIT_ADDRESS_EVENTS.CONFIRM,
      originAddress,
      adjustedAddress,
    }),
    /// BUR Step 3
    scribeExpressBukUploadSetupDeliveryDefault: scribeSetupDeliveriesCommonData => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_DEFAULT,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB,
      eventName: SCRIBE_EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_EVENTS.DEFAULT,
      scribeSetupDeliveriesCommonData,
    }),
    scribeExpressBukUploadSetupDeliverySelectAll: () => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_SELECT_ALL,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB,
      eventName:
        SCRIBE_EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_EVENTS.SELECT_ALL,
    }),
    scribeExpressBukUploadSetupDeliveryEditServiceType: () => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_EDIT_SERVICE_TYPE,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB,
      eventName:
        SCRIBE_EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_EVENTS.EDIT_SERVICE_TYPE,
    }),
    scribeExpressBukUploadSetupDeliveryEditVehicleType: () => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_EDIT_VEHICLE_TYPE,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB,
      eventName:
        SCRIBE_EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_EVENTS.EDIT_VEHICLE_TYPE,
    }),
    scribeExpressBukUploadSetupDeliveryEditAddOn: () => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_EDIT_ADD_ON,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB,
      eventName:
        SCRIBE_EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_EVENTS.EDIT_ADD_ON,
    }),
    scribeExpressBukUploadSetupDeliveryConfirm: (
      scribeSetupDeliveriesCommonData,
      scribeFare,
    ) => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_CONFIRM,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB,
      eventName: SCRIBE_EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_EVENTS.CONFIRM,
      scribeSetupDeliveriesCommonData,
      scribeFare,
    }),

    scribeExpressBulkUploadSetupDeliveryToggleMultiStop: isGrouped => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_TOGGLE_MULTI_STOP,
      isGrouped,
    }),

    scribeExpressBulkUploadSetupDeliveryReviewMultiStop: (cta, doNotShowAgain) => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_REVIEW_MULTI_STOP,
      cta,
      doNotShowAgain
    }),

    scribeExpressBulkUploadSetupDeliveryFindShortestRoute: deliveryID => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_FIND_SHORTEST_ROUTE,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB,
      eventName: SCRIBE_EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_EVENTS.FIND_SHORTEST_ROUTE,
      deliveryID,
    }),

    scribeExpressBulkUploadSetupDeliveryUseOriginalRoute: deliveryID => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_USE_ORIGINAL_ROUTE,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB,
      eventName: SCRIBE_EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_EVENTS.USE_ORIGINAL_ROUTE,
      deliveryID,
    }),

    scribeExpressBulkUploadSetupDeliveryFindShortestRouteResults: (deliveryID, status) => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_FIND_SHORTEST_ROUTE_RESULTS,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB,
      eventName: SCRIBE_EXPRESS_BULK_UPLOAD_SETUP_DELIVERY_WEB_EVENTS.FIND_SHORTEST_ROUTE_RESULTS,
      deliveryID,
      status,
      forceTrack: true,
    }),

    scribeExpressNewBulkUploadErrorPageDefault: errorCode => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_ERROR_PAGE_DEFAULT,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_ERROR_PAGE,
      eventName: SCRIBE_EXPRESS_BULK_UPLOAD_ERROR_PAGE.DEFAULT,
      errorCode,
    }),
    scribeExpressNewBulkUploadErrorPageConfirmInvalidField: errorCode => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_ERROR_PAGE_CONFIRM_INVALID_FIELD,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_ERROR_PAGE,
      eventName: SCRIBE_EXPRESS_BULK_UPLOAD_ERROR_PAGE.CONFIRM_INVALID_FIELD,
      errorCode,
    }),

    /// BUR Step 4
    scribeExpressBukUploadBookDefault: (fare, code, totalDeliveries) => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_BOOK_WEB_DEFAULT,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_BOOK_WEB,
      eventName: SCRIBE_EXPRESS_BULK_UPLOAD_BOOK_WEB_EVENTS.DEFAULT,
      fare,
      code,
      totalDeliveries,
    }),
    scribeExpressBukUploadBookPaymentMethod: (paymentMethod, fare) => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_BOOK_WEB_PAYMENT_METHOD,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_BOOK_WEB,
      eventName: SCRIBE_EXPRESS_BULK_UPLOAD_BOOK_WEB_EVENTS.PAYMENT_METHOD,
      paymentMethod,
      fare,
    }),
    scribeExpressBukUploadBookOffers: (selectedOffer, fare) => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_BOOK_WEB_OFFERS,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_BOOK_WEB,
      eventName: SCRIBE_EXPRESS_BULK_UPLOAD_BOOK_WEB_EVENTS.OFFERS,
      selectedOffer,
      fare,
    }),
    scribeExpressBukUploadBookBook: (
      selectedOffer,
      fare,
      code,
      totalDeliveries,
      uploadedDistrict,
    ) => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_BOOK_WEB_BOOK,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_BOOK_WEB,
      eventName: SCRIBE_EXPRESS_BULK_UPLOAD_BOOK_WEB_EVENTS.BOOK,
      selectedOffer,
      fare,
      code,
      totalDeliveries,
      uploadedDistrict,
    }),
  }),
});
